var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighwayNetworkLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33207 0H11.7321V7.33341H13.199V0H17.599L19.0657 7.33341H21.3341L18.4008 10.2667H2.93333V11.7334H0V7.33341H5.86538L7.33207 0ZM16.9343 11.7333H13.199V15.4686L16.9343 11.7333ZM11.7321 16.9355V11.7333H4.98541L2.93207 22H6.66755L11.7321 16.9355Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6267 13.8995L33.4551 11.071L26.384 3.99998L7.99923 22.3848L15.0703 29.4558L17.1916 27.3345L14.5989 24.7418L15.306 24.0347L17.8987 26.6274L19.3129 25.2132L15.0703 20.9705L15.7774 20.2634L20.02 24.5061L21.4343 23.0919L18.8415 20.4991L19.5486 19.792L22.1414 22.3848L23.5556 20.9705L19.3129 16.7279L20.02 16.0208L24.2627 20.2634L25.6769 18.8492L23.0842 16.2565L23.7913 15.5494L26.384 18.1421L27.7982 16.7279L23.5556 12.4853L24.2627 11.7782L28.5053 16.0208L29.9195 14.6066L27.3268 12.0139L28.0339 11.3067L30.6267 13.8995Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighwayNetworkLengthIcon);
export default __webpack_public_path__ + "static/media/highwayNetworkLengthIcon.10ddf2f6411ca4f0710333e5ac9f4064.svg";
export { ForwardRef as ReactComponent };